class AppReview {
  constructor() {
    if(!document.querySelector('#AppReview')){
      return
    }

    this.max = 5
    this.forms = document.querySelectorAll('#AppReview .ajaxForm')
    this.question_btn = document.querySelectorAll('#AppReview .js-AppReview-question')
    this.range_inputs = document.querySelectorAll('#AppReview .app-review__field-control[type="range"]')

    this.forms.forEach((form) => {
      form.addEventListener('input', (e) => {
        this.enableSubmit(e)
      })
    })

    this.question_btn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.addQuestion(e)
      })
    })

    this.range_inputs.forEach((input) => {
      input.addEventListener('input', (e) => {
        this.rangeUpdate(e)
      })
    })
  }

  insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  }

  enableSubmit = (e) => {
    const form = e.currentTarget
    const submit  = form.querySelector('.js-AppReview-save')

    submit.querySelector('span').innerHTML = submit.getAttribute('data-label')

    submit.classList.remove('disabled')
  }

  rangeUpdate = (e) => {
    let points;
    const value = e.currentTarget.value
    const parent = e.currentTarget.closest('.app-review__field')
    const card = parent.closest('.app-review')
    const target = parent.querySelector('span')

    const allFields  = card.querySelectorAll('.app-review__field-control[type="range"]')
    const total  = card.querySelector('.app-review__header span')

    points = 0;
    allFields.forEach(field => {
      points = points + Number(field.value)
    });

    target.innerHTML = value
    total.innerHTML = points
  }

  addQuestion = (e) => {
    const el = e.currentTarget
    const card = el.closest('.app-review')
    const group = card.querySelector('.app-review__questions')
    const field = group.querySelector('.app-review__field:last-child')
    const clone = field.cloneNode(true)

    clone.querySelector('textarea').value = "";
    clone.querySelector('textarea').removeAttribute('readonly')
    clone.querySelector('textarea').removeAttribute('disabled')

    if(group.querySelectorAll('.app-review__field').length >= this.max){
      alert('Maximálně lze položit '+this.max+' dotazů.')

      return
    }

    if(!group.classList.contains('hide')){
      this.insertAfter(clone, field)
    }

    group.classList.remove('hide')
  }

}

new AppReview()
